import { atom, useAtom } from 'jotai';
import { PlatformUserConfig } from 'common/types';
import { DefaultPlatformModeRate, DefaultPlatformUserRate, DefaultPlatformEnterpriseRate } from '..';

export const PlatformUserConfigAtom = atom<PlatformUserConfig>({
  platformUserRate: DefaultPlatformUserRate,
  platformModeRate: DefaultPlatformModeRate,
  platformEnterpriseRate: DefaultPlatformEnterpriseRate,
});

export const usePlatformUserConfig = () => {
  const [platformUserConfig, setPlatformUserConfig] = useAtom(PlatformUserConfigAtom);

  return {
    platformUserConfig,
    setPlatformUserConfig,
  };
};
